"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationWorkflowEEOQuestion = exports.CommonControlsText = exports.RichTextViewer = exports.CommonControlsSectionHeader = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.ApplicationWorkflowEEOQuestionAction = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var player_rich_text_viewer_1 = require("player-rich-text-viewer");
exports.RichTextViewer = player_rich_text_viewer_1.default;
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var ApplicationWorkflowEEOQuestion_1 = require("../ApplicationWorkflowEEOQuestion/ApplicationWorkflowEEOQuestion");
Object.defineProperty(exports, "ApplicationWorkflowEEOQuestion", { enumerable: true, get: function () { return ApplicationWorkflowEEOQuestion_1.ApplicationWorkflowEEOQuestion; } });
var ApplicationWorkflowEEOQuestionAction = (function (_super) {
    __extends(ApplicationWorkflowEEOQuestionAction, _super);
    function ApplicationWorkflowEEOQuestionAction(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowEEOQuestionAction.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowEEOQuestionAction.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowEEOQuestionAction.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowEEOQuestionAction.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowEEOQuestionAction.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowEEOQuestionAction.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowEEOQuestionAction.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowEEOQuestionAction.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowEEOQuestionAction.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            var question_handler = function () {
                var question_result = $this.state.viewModel.questions.map(function (question, question$index) {
                    $this.state.viewModel.question = question;
                    $this.state.viewModel.question$index = question$index;
                    return [React.createElement(GridCol_1.GridCol, { key: question$index.toString() + 0, children: [React.createElement(ApplicationWorkflowEEOQuestion_1.ApplicationWorkflowEEOQuestion, { key: question$index.toString() + 0, question: $this.state.viewModel.question, expandableFadeHeight: $this.state.viewModel.question.expandableFadeHeight, ShowLessText: $this.state.viewModel.question.showLessText, ShowMoreText: $this.state.viewModel.question.showMoreText, onQuestionAnswered: _this._proxyEvent("onQuestionAnswered", question, question$index, "repeaterArgs") })] }), React.createElement(GridCol_1.GridCol, { key: question$index.toString() + 1, isVisible: $this.state.viewModel.question.displayFolloUpQuestion, children: [React.createElement(ApplicationWorkflowEEOQuestion_1.ApplicationWorkflowEEOQuestion, { key: question$index.toString() + 0, question: $this.state.viewModel.question.followUpEeoQuestion, ShowLessText: $this.state.viewModel.ShowLessText, ShowMoreText: $this.state.viewModel.ShowMoreText, onQuestionAnswered: _this._proxyEvent("onQuestionAnswered", question, question$index, "repeaterArgs") })] })];
                });
                delete $this.state.viewModel.question;
                delete $this.state.viewModel.question$index;
                return question_result;
            };
            return [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterVertical: "Xsmall", colsWidth: "12", children: [React.createElement(GridCol_1.GridCol, { key: 0, children: [React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: $this.state.viewModel.actionItem.title, tag: $this.state.viewModel.parentTag })] }), React.createElement(GridCol_1.GridCol, { key: 1, children: [React.createElement(player_rich_text_viewer_1.default, { key: 0, html: $this.state.viewModel.actionItem.instructions, allowedTags: $this.state.viewModel.constants.PRTV_ALLOWED_TAGS, allowedAttributes: $this.state.viewModel.constants.PRTV_ALLOWED_ATTRIBUTES })] }), React.createElement(GridCol_1.GridCol, { key: 2, isVisible: $this.state.viewModel.showPreviewMessage, children: [React.createElement(Text_1.Text, { key: 0, text: $this.state.viewModel.previewMessage, decoration: "Italic", color: "Meta" })] }), question_handler()] })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkfloweeoquestionaction" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowEEOQuestionAction.defaultProps = {
        actionItem: "",
        onDataChanged: function () { }
    };
    return ApplicationWorkflowEEOQuestionAction;
}(React.Component));
exports.ApplicationWorkflowEEOQuestionAction = ApplicationWorkflowEEOQuestionAction;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowEEOQuestionAction"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowEEOQuestionAction/ApplicationWorkflowEEOQuestionAction.js
// module id = 723
// module chunks = 0